import React from 'react';
import ReactDOMServer from 'react-dom/server';
import moment from 'moment-timezone';

import { DATE_CHART_FORMAT_FULL } from '../../constants/date';

export const complexRetentionChartTooltip = (hoverPoint) =>
  ReactDOMServer.renderToStaticMarkup(
    <div>
      <div className="tooltip-bold">{hoverPoint.category}</div>
      <div>
        <span style={{ color: hoverPoint.color }}>{hoverPoint.eventName}</span>
        <span>{`: `}</span>
        <span className="tooltip-bold">{hoverPoint.y}%</span>
        <span>{` is `}</span>
        <span className="tooltip-bold">{hoverPoint.sum}</span>
        <span>{` of `}</span>
        <span className="tooltip-bold">{hoverPoint.total}</span>
      </div>
    </div>
  );

export const complexRetentionByDateChartTooltip = (hoverPoint) =>
  ReactDOMServer.renderToStaticMarkup(
    <div>
      <div className="tooltip-bold">
        {moment
          .tz(hoverPoint.x, hoverPoint.timezone)
          .add(hoverPoint.timeShift, hoverPoint.timeUnit.toLowerCase())
          .format(DATE_CHART_FORMAT_FULL)}
      </div>
      <div>
        <span style={{ color: hoverPoint.color }}>{hoverPoint.eventName}</span>
        <span>{`: `}</span>
        <span className="tooltip-bold">{hoverPoint.y}%</span>
        <span>{` is `}</span>
        <span className="tooltip-bold">{hoverPoint.sum}</span>
        <span>{` of `}</span>
        <span className="tooltip-bold">{hoverPoint.total}</span>
      </div>
    </div>
  );
